import {MenuOption} from "../../../../gd-components/popover-menu/popover-menu/const";
import {TaskAction} from "../@const";
import Task from "../../../../model2/task/task";

export type Props = {
    task                : Task

    hiddenActions?      : TaskAction[],
    disabledActions?    : string[]
}

// turns the task into a support ticket - see docs/code/support-ticket-system.md.
// Not offered inside a Module Ticket project, where every task is a ticket
// already, or once the task already is one.
export function taskMore_initShareAsTicket(props: Props, menuOptions: MenuOption[]) {

    if (props.hiddenActions?.includes(TaskAction.SHARE_AS_TICKET)) {
        return
    }

    const task    = props.task
    const project : any = gd.session.projects.get(task.projectId)

    if (project?.isSupportSystem) return
    if (task.properties?.ticketView?.enabled) return

    const onClick = async () => {
        await gd.layout.viewLoading.showBusyAsync()

        try {
            await gd.api.Task.setTicketViewEnabled(task.id, true).promise()
        } finally {
            gd.layout.viewLoading.hide()
        }
    }

    menuOptions.push({
        icon        : "i5-link",
        label       : "Share as ticket",
        onClick     : onClick,
        disabled    : !task.acl.canChangeCRM || props.disabledActions?.includes('share-as-ticket') || !gd.modules.supportTicket.enabled,
        isPro       : !gd.company.license.isBusiness

    })
}
